import { CompanyModelPolicySchema, EFFORT_LEVELS, IdSchema, LocalizedTextSchema, ModelTierSchema, } from "@uzverse/core";
import { z } from "zod";
/** One selectable model, as the owner panel and the web client show it. */
export const ModelCatalogModelSchema = z.object({
    id: z.string().min(1),
    label: LocalizedTextSchema,
    /** Cost/strength order, 0 = cheapest. */
    rank: z.number().int().min(0),
    supportsEffort: z.boolean(),
    /** The tiers currently mapped to this model by engine configuration. */
    tiers: z.array(ModelTierSchema),
});
/** Answer of the node's and the owner API's model catalog routes. */
export const ModelCatalogResponseSchema = z.object({
    models: z.array(ModelCatalogModelSchema),
    effortLevels: z.array(z.enum(EFFORT_LEVELS)),
});
/** Body of `PUT NODE_EXTRA_API.admin.modelPolicy`. */
export const SetModelPolicyBodySchema = z.object({
    policy: CompanyModelPolicySchema,
    by: IdSchema,
});
//# sourceMappingURL=models.js.map